// extracted by mini-css-extract-plugin
module.exports = {"root":"Description_root__VMXGB"};